import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ShieldIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M3.19995 5.26004V14.28C3.19995 17.34 7.94995 19.83 11.58 22.26C11.7299 22.35 11.85 22.44 12 22.56C12.15 22.47 12.27 22.38 12.42 22.26C16.05 19.83 20.7999 17.34 20.7999 14.28V5.26004L12 1.29004L3.19995 5.26004ZM17.73 8.52004L12.33 13.95L11.01 15.27L7.16995 11.43L8.48995 10.11L11.01 12.63L16.41 7.20004L17.73 8.52004Z'
                fill='currentColor'
            />
        </>
    ),
})

ShieldIcon.displayName = 'ShieldIcon'
